// src/pages/Invoices/Report/ItemsProfitDetail.jsx
import React from 'react';
import ProfitReportPage, { ITEMS_PROFIT_DETAIL } from './ProfitReportPage';

export default function ItemsProfitDetail() {
  return <ProfitReportPage config={ITEMS_PROFIT_DETAIL} />;
}
